import { memo } from "react";
import _ from "lodash";

import Box from "components/Box";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";

import PrintableDDSectionWrapper from "./PrintableDDSectionWrapper";

const PrintableMemoDDSection = ({ section }: { section: IMemoSection }) => (
  <>
    <SectionHeader label={section.title} />
    <SectionContent>
      {_.isArray(section.fields) &&
        _.uniqBy(section.fields, "company_custom_field_id").map((field) => (
          <Box
            key={field.company_custom_field_id}
            sx={{
              marginTop: 0.25,
              "& .MuiIconButton-root": { visibility: "hidden" },
              "&:hover .MuiIconButton-root": {
                visibility: "visible",
              },
              ...(section.table_section_compact_view
                ? {
                    "tr, td, th, table, tbody": {
                      padding: 0.5,
                      borderTop: 0,
                      borderLeft: 0,
                      borderRight: 0,
                    },
                  }
                : {}),
            }}
            data-testid="dd-field"
          >
            <PrintableDDSectionWrapper
              field={field}
              isNASection={section.is_na}
            />
          </Box>
        ))}
    </SectionContent>
  </>
);

export default memo(PrintableMemoDDSection, (prev, next) => {
  return _.isEqual(prev.section, next.section);
});
